import * as yup from "yup";
import { validationMessages } from "./messages";

export const emailValidationSchema = yup
  .string()
  .email(validationMessages.invalidEmail);
